import { KnmResultDecisionStatusEnum } from 'APIPackage/KnmModule/enums/KnmResultDecisionStatusEnum';

export const mapResultDecisionStatusToColor: Record<KnmResultDecisionStatusEnum, 'green' | 'red' | 'yellow'> = {
  [KnmResultDecisionStatusEnum.COMPLETED]: 'green',
  [KnmResultDecisionStatusEnum.NOT_COMPLETED]: 'red',
  [KnmResultDecisionStatusEnum.CANCELED]: 'red',
};
